import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais',
)({
  component: DocumentosDigitaisLayout,
})

function DocumentosDigitaisLayout() {
  const { dashboardId } = Route.useParams()

  return (
    <RequireModule module={MODULES.DOCUMENTOS} dashboardId={dashboardId}>
      <Outlet />
    </RequireModule>
  )
}
